// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__SJJro","name":"styles_name__1Fi6w","description":"styles_description__SNZ1R","actionButtons":"styles_actionButtons__129RT"};